/* Deepercent theme — small progressive enhancements. Every feature works without JS. */
(function () {
  'use strict';

  function announce(message) {
    var region = document.getElementById('LiveRegion');
    if (region) { region.textContent = ''; setTimeout(function () { region.textContent = message; }, 50); }
  }

  /* Mobile menu drawer */
  function initDrawer() {
    var drawer = document.getElementById('MenuDrawer');
    if (!drawer) return;
    var openers = document.querySelectorAll('[data-drawer-open]');
    var closers = drawer.querySelectorAll('[data-drawer-close]');
    var lastFocus = null;

    function open() {
      lastFocus = document.activeElement;
      drawer.classList.add('is-open');
      drawer.removeAttribute('inert');
      drawer.setAttribute('aria-hidden', 'false');
      openers.forEach(function (b) { b.setAttribute('aria-expanded', 'true'); });
      document.body.style.overflow = 'hidden';
      var first = drawer.querySelector('[data-drawer-close]');
      if (first) first.focus();
    }
    function close() {
      drawer.classList.remove('is-open');
      drawer.setAttribute('inert', '');
      drawer.setAttribute('aria-hidden', 'true');
      openers.forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
      document.body.style.overflow = '';
      if (lastFocus) lastFocus.focus();
    }
    openers.forEach(function (b) { b.addEventListener('click', open); });
    closers.forEach(function (b) { b.addEventListener('click', close); });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && drawer.classList.contains('is-open')) close();
    });
  }

  /* Localization selects submit on change (form also has a submit button for no-JS) */
  function initLocalization() {
    document.querySelectorAll('[data-localization-form] select').forEach(function (select) {
      select.addEventListener('change', function () { select.form.submit(); });
    });
    document.querySelectorAll('[data-localization-form] [data-no-js]').forEach(function (el) { el.hidden = true; });
  }

  /* Quantity steppers */
  function initQuantity(root) {
    (root || document).querySelectorAll('[data-qty]').forEach(function (wrap) {
      if (wrap.dataset.bound) return;
      wrap.dataset.bound = '1';
      var input = wrap.querySelector('input');
      wrap.querySelectorAll('button[data-step]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var min = parseInt(input.min || '0', 10);
          var next = Math.max(min, (parseInt(input.value, 10) || 0) + parseInt(btn.dataset.step, 10));
          input.value = next;
          input.dispatchEvent(new Event('change', { bubbles: true }));
        });
      });
    });
  }

  /* Product variant picker: maps selected options to a variant from embedded JSON */
  function initProduct() {
    document.querySelectorAll('[data-product-form]').forEach(function (form) {
      if (form.dataset.bound) return;
      form.dataset.bound = '1';
      var dataEl = form.querySelector('[data-variants]');
      var variants = dataEl ? JSON.parse(dataEl.textContent) : [];
      var idInput = form.querySelector('input[name="id"]');
      var button = form.querySelector('[type="submit"]');
      var buttonLabel = button && button.querySelector('span');
      var section = form.closest('[data-section]');
      var priceEl = section && section.querySelector('[data-price]');

      form.addEventListener('change', function (e) {
        if (!variants.length || !e.target.matches('[data-option]')) return;
        var selected = Array.prototype.map.call(form.querySelectorAll('[data-option-group]'), function (group) {
          var checked = group.querySelector('input:checked');
          return checked ? checked.value : null;
        });
        var variant = variants.find(function (v) {
          return v.options.every(function (opt, i) { return opt === selected[i]; });
        });
        if (!variant) {
          button.disabled = true;
          buttonLabel.textContent = window.theme.strings.unavailable;
          return;
        }
        idInput.value = variant.id;
        button.disabled = !variant.available;
        buttonLabel.textContent = variant.available ? window.theme.strings.addToCart : window.theme.strings.soldOut;
        if (priceEl && variant.price_html) priceEl.innerHTML = variant.price_html;
        if (form.hasAttribute('data-update-url')) {
          var url = new URL(window.location.href);
          url.searchParams.set('variant', variant.id);
          window.history.replaceState({}, '', url.toString());
        }
      });

      /* AJAX add to cart; falls back to normal form post on error */
      form.addEventListener('submit', function (e) {
        if (!window.fetch) return;
        e.preventDefault();
        var message = form.querySelector('[data-product-message]');
        button.setAttribute('aria-busy', 'true');
        button.disabled = true;
        fetch(window.theme.routes.cart_add_url + '.js', {
          method: 'POST',
          headers: { 'Accept': 'application/json' },
          body: new FormData(form)
        })
          .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, data: d }; }); })
          .then(function (res) {
            if (!res.ok) throw new Error(res.data.description || window.theme.strings.error);
            if (message) message.textContent = window.theme.strings.added;
            announce(window.theme.strings.added);
            return fetch(window.theme.routes.cart_url + '.js').then(function (r) { return r.json(); });
          })
          .then(function (cart) {
            if (!cart) return;
            document.querySelectorAll('[data-cart-count]').forEach(function (el) {
              el.textContent = cart.item_count;
              el.hidden = cart.item_count === 0;
            });
          })
          .catch(function (err) {
            if (message) message.textContent = err.message;
            announce(err.message);
          })
          .finally(function () {
            button.removeAttribute('aria-busy');
            button.disabled = false;
          });
      });
    });
  }

  /* Cart page: quantity changes submit the cart form (update) */
  function initCart() {
    var form = document.querySelector('[data-cart-form]');
    if (!form) return;
    var timer;
    form.addEventListener('change', function (e) {
      if (!e.target.matches('input[name="updates[]"]')) return;
      clearTimeout(timer);
      timer = setTimeout(function () {
        var update = document.createElement('input');
        update.type = 'hidden';
        update.name = 'update';
        update.value = '1';
        form.appendChild(update);
        form.submit();
      }, 500);
    });
  }

  /* Collection sort + filters submit on change */
  function initFacets() {
    document.querySelectorAll('[data-facets-form]').forEach(function (form) {
      form.addEventListener('change', function (e) {
        if (e.target.type === 'number') return;
        form.submit();
      });
      form.querySelectorAll('[data-no-js]').forEach(function (el) { el.hidden = true; });
      if (window.matchMedia('(min-width: 990px)').matches) {
        form.querySelectorAll('[data-open-desktop]').forEach(function (el) { el.open = true; });
      }
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    initDrawer();
    initLocalization();
    initQuantity();
    initProduct();
    initCart();
    initFacets();
  });
  document.addEventListener('shopify:section:load', function (e) {
    initQuantity(e.target);
    initProduct();
    initDrawer();
  });
})();
